import * as React from "react"
export const ImageAddIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={22}
    className="stroke-fg-1"
    height={22}
    viewBox="0 0 20 20"
    fill="none"
    {...props}>
    <path
      stroke="inherit"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M10.417 2.5H6.5c-1.4 0-2.1 0-2.635.272a2.5 2.5 0 0 0-1.093 1.092C2.5 4.4 2.5 5.1 2.5 6.5v7c0 1.4 0 2.1.272 2.635a2.5 2.5 0 0 0 1.093 1.093c.535.272 1.235.272 2.635.272h7.667c.775 0 1.162 0 1.48-.085a2.5 2.5 0 0 0 1.768-1.768c.085-.318.085-.705.085-1.48m-1.667-7.5v-5m-2.5 2.5h5M8.75 7.083a1.667 1.667 0 1 1-3.333 0 1.667 1.667 0 0 1 3.333 0Zm3.742 2.848-7.05 6.408c-.396.36-.594.541-.612.697a.417.417 0 0 0 .14.36c.117.103.385.103.921.103h7.822c1.2 0 1.8 0 2.27-.201a2.5 2.5 0 0 0 1.316-1.315c.201-.471.201-1.071.201-2.27 0-.404 0-.606-.044-.793a1.667 1.667 0 0 0-.312-.649c-.119-.152-.276-.278-.591-.53L14.22 9.877c-.315-.253-.473-.379-.646-.423a.833.833 0 0 0-.465.014c-.17.056-.32.191-.618.463Z"
    />
  </svg>
)
